export default __webpack_public_path__ + "static/media/index.2d9fb415.less";